import React from "react";
import { Container, Row, Col } from "shards-react";
import TaskComponent from "../components/tasks/Task";

function TaskView(props) {
  const { id, is_productive } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row>
        <Col md="12">
          <TaskComponent id={id} isProductive={is_productive} />
        </Col>
      </Row>
    </Container>
  );
}
export default TaskView;
